import AdminLayout from '../../layouts/AdminLayout'
import { Box, Flex } from '@chakra-ui/react'
import React from 'react'

export default () => {
    return <Box w={'100%'}>Dashboard</Box>
}
